import React from 'react'
import { Navigate, Outlet, useNavigate } from 'react-router-dom'

import { useAuth } from 'hooks'
import { ROUTES } from 'routes'

export const ProtectedRoute = (props: any) => {
  const { redirectPath = ROUTES.SIGN_IN } = props
  const navigate = useNavigate()

  const { isAuthenticated } = useAuth()

  if (!isAuthenticated) {
    navigate(redirectPath)
  }

  return <Outlet />
}
